import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--pricelists--form"
export default class extends Controller {
  static targets = [
    "spinner",
    "form",
    "content"
  ]

  connect() { }

  formTargetConnected() {
    this.spinnerTarget.classList.add("hidden")
  }

  submitForm(event) {
    event.preventDefault()

    this.contentTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
    this.formTarget.requestSubmit()
  }
}
